// React
import React, { useEffect, useState } from "react";

// MUI
import {
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  IconButton,
  Collapse,
  Autocomplete,
  Paper,
  Tooltip,
  Checkbox,
  CircularProgress,
} from "@mui/material";

//MUI ICON
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";

// Formik
import { useFormik } from "formik";
import * as Yup from "yup";

//Components
import Dropzone from "components/Dropzone_one";
import {
  GradientButton,
  GradientButtonOutline,
  GradientShadow,
} from "components/GradientButton";
import Form from "components/Form/FormInterest";

// API
import api from "_api";

// Other
import { Divider } from "antd";
import Swal from "sweetalert2";
import ReactDOM from "react-dom";
import SaveIcon from "assets/images/SaveIcon.svg";
import { CheckCircle } from "@mui/icons-material";

// ฟังก์ชันสำหรับสร้าง validation schema ให้กับฟอร์ม
const validationSchema = Yup.object({
  // payment_channel: Yup.string().required("โปรดระบุช่องทางการชำระ"),
  notes_condition: Yup.string().required("โปรดระบุหมายเหตุ"),
});

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field ของผู้ที่มาซื้อ
const customerFields = [
  {
    label: "คำนำหน้า",
    name: "prefix",
    type: "text",
    disabled: true,
  },
  {
    label: "ชื่อ-นามสกุล",
    name: "fullName",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "เลขบัตรประชาชน",
    name: "idCardNumber",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "เบอร์โทรศัพท์",
    name: "phoneNumber",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "ที่อยู่",
    name: "address",
    type: "text",
    // required: true,
    disabled: true,
  },
  {
    label: "สัญชาติ",
    name: "nationality",
    type: "text",
    disabled: true,
  },
];

const conditionPawn = [
  {
    label: "ช่องทางการชำระ",
    name: "payment_channel",
    type: "autocomplete",
    required: true,
    // width: "90%",
    // specialText: "เดือน",
  },
  {
    label: "หมายเหตุ",
    name: "notes_condition",
    type: "text",
    required: true,
  },
];

// กำนหดตัวแปรสำหรับการดึงข่้อมูลไปแสดงผลใน Field หมวดหมู่
const categoryOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];

const payment_channelOptions = [
  { label: "เงินสด", id: "เงินสด" },
  { label: "เงินโอน", id: "โอนผ่านธนาคาร" },
  { label: "เช็ค", id: "เช็ค" },
  { label: "บัตรเครดิต", id: "บัตรเครดิต" },
];

const ModalInterest = ({
  open,
  onClose,
  selectedProduct,
  fetchProductData,
}) => {
  // ตัวแปรสำหรับเก็บข้อมูลรูปภาพ
  const [files1, setFiles1] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [error1, setError1] = useState(null);
  const [error2, setError2] = useState(null);
  const [initialProductUrls, setInitialProductUrls] = useState([]);
  const [deletedImageIds, setDeletedImageIds] = useState([]);

  // ตัวแปรสำหรับเก็บข้อของ Box แสดง Product
  const [productBoxes, setProductBoxes] = useState([
    { id: 1, isExpanded: false },
  ]);
  const [expandedRow, setExpandedRow] = useState(null); // เก็บการแสดงผลของ Row ในการ Explaned
  const [statusSave, setStatusSave] = useState(false); // เก็บ status หลังจากมีการเพิ่ม Box
  const [currentStep, setCurrentStep] = useState(1); // Track the current step
  // const [selectedOption, setSelectedOption] = useState(1); // For selecting the display count option
  const [isHovered, setIsHovered] = useState(false);
  const [activeButton, setActiveButton] = useState("pawnContract");

  // เก็บข้อมูลอัตราดอกเบี้ย
  const [interestRate, setInterestRate] = useState(0);
  //เก็บตัวแปร id หลังจากสร้าง product เสร็จ
  const [newIds, setNewIds] = useState([
    {
      product_id: 0,
      amount: 0,
      total_price: 0,
    },
  ]);

  // loading and status success for create order
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  // keep order when create order success
  const [order, setOrder] = useState(null);

  //กรณีมีการส่งข้อมูลเข้ามาจะแสดง
  useEffect(() => {
    if (selectedProduct) {
      console.log({ selectedProduct });
      setExpandedBoxes(selectedProduct?.order_pawns[0].id);
      setInterestRate(selectedProduct?.order_pawns[0].interest_rate || 0);
      // ตรวจสอบว่า order_pawns มีข้อมูล และเป็นอาร์เรย์
      if (
        selectedProduct?.order_pawns &&
        Array.isArray(selectedProduct.order_pawns)
      ) {
        const formikValues = {};

        selectedProduct.order_pawns.forEach((pawn) => {
          const id = pawn.id; // ใช้ `id` แยกฟิลด์แต่ละ box
          const category_id = pawn.category_id;

          // เพิ่มฟิลด์สำหรับแต่ละ box
          formikValues[`product_code_${id}`] = pawn.product_code || "";
          formikValues[`product_code_com_${id}`] = pawn.product_code_com || "";
          formikValues[`product_name_${id}`] = pawn.product_name || "";
          formikValues[`category_id_${id}`] =
            categoryOptions.find((category) => category.id === category_id) ||
            null;
          formikValues[`detail_${id}`] = pawn.detail || "";
          formikValues[`blemishes_${id}`] = pawn.blemishes || "";
          formikValues[`size_${id}`] = pawn.size || "";
          formikValues[`total_amount_${id}`] = pawn.pawn_amount || 1;
          formikValues[`price_${id}`] = pawn.product_price || 0;
          formikValues[`total_price_${id}`] = pawn.pawn_price || 0;
          formikValues[`notes_${id}`] = pawn.notes || "";

          // เก็บรูปภาพในฟิลด์ `images_${id}`
          formikValues[`images_${id}`] = Array.isArray(pawn.pictures)
            ? pawn.pictures.flatMap((picObj) =>
                Array.isArray(picObj.picture) ? picObj.picture : []
              )
            : [];
        });
        console.log({ selectedProduct });

        // เพิ่มข้อมูลลูกค้า
        formikValues.order_code = selectedProduct.order_code || "";
        formikValues.fullName = selectedProduct.customer_name || "";
        formikValues.idCardNumber = selectedProduct.idcard || "";
        formikValues.phoneNumber = selectedProduct.phonenumber || "";
        formikValues.address = selectedProduct.address || "";
        formikValues.product_images = selectedProduct.picture || [];
        formikValues.late_fees = selectedProduct.late_fees || 0;
        formikValues.created_date = selectedProduct.created_at || 0;

        // ตั้งค่า Formik values
        formik.setValues(formikValues);
      }
    }
  }, [selectedProduct]);

  //ฟังก์ชันแสดง Explanded
  const handleExpandClick = (rowId) => {
    setExpandedRow(expandedRow === rowId ? null : rowId);
  };

  //ฟังก์ชันลบ Box
  const handleDeleteBox = (rowId) => {
    if (productBoxes.length > 1) {
      setProductBoxes((prevBoxes) =>
        prevBoxes.filter((box) => box.id !== rowId)
      );
    } else {
      alert("Cannot delete the last remaining box.");
    }
  };

  //ฟังก์ชันเปลี่ยนหน้า
  const handleNextStep = () => {
    setCurrentStep(currentStep + 1); // Go to the next "page"
  };

  //ฟังก์ชันสำหรับการเปลี่ยนหน้าแสดงผลใน Modal
  const handleBackToStep1 = () => {
    setCurrentStep(1); // Reset back to the first step if needed
  };

  // ฟังก์ชันเพิ่ม product box
  const addProductBox = () => {
    if (productBoxes.length < 15) {
      setProductBoxes([
        ...productBoxes,
        { id: productBoxes.length + 1, isExpanded: false },
      ]);
      setStatusSave(false);
    } else {
      alert("คุณสามารถเพิ่มสินค้าได้สูงสุด 15 รายการเท่านั้น");
    }
  };

  // ฟังก์ชัน explan
  const toggleExpand = (id) => {
    setExpandedBoxes((prevId) => (prevId === id ? null : id)); // หาก id ซ้ำให้ปิด, หากต่างให้เปิด
  };
  // สร้างรหัสตัวแปรตามจำนวน Box ที่เพิ่ม
  const generateInitialValues = (selectedProduct) =>
    productBoxes.reduce(
      (values, { id }) => ({
        ...values,
        [`product_id_${id}`]: "",
        [`product_code_${id}`]: "",
        [`product_code_com_${id}`]: "",
        [`product_name_${id}`]: "",
        [`category_id_${id}`]: "",
        [`detail_${id}`]: "",
        [`blemishes_${id}`]: "",
        [`size_${id}`]: "",
        [`total_amount_${id}`]: "",
        [`price_${id}`]: "",
        [`total_price_${id}`]: "",
        [`notes_${id}`]: "",
        [`images_${id}`]: [],
      }),
      {}
    );

  // นับจำนวน Box
  // const productBoxCount = productBoxes.length;

  // console.log("display new id in array", productBoxes);

  // Function to convert object to FormData
  const transformObjectToFormData = (obj) => {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      if (key === "category_id" && value?.id) {
        formData.append(key, value.id);
      } else if (key === "period" && Array.isArray(value)) {
        // แปลง period เป็น JSON string ก่อน
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, JSON.stringify(item));
        });
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          formData.append(`${key}[${index}]`, item);
        });
      } else if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    return formData;
  };

  // Formik hook
  const formik = useFormik({
    initialValues: {
      payment_channel: "",
      notes_condition: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        console.log("Submitting values:", values);

        if (!selectedTransactions.length) {
          alert("กรุณาเลือก Transaction");
          return;
        }

        // สร้าง orderDataArray จาก selectedTransactions
        const orderData = {
          // description: values.notes_condition,
          period: selectedTransactions.map((transaction) => ({
            id: transaction.id,
            payment_method: values.payment_channel?.id || "", // ตรวจสอบค่าของ payment_channel
          })),
          picture: files1.map((fileObj) => fileObj.file), // Make sure 'files1' is defined
        };

        // console.log("Order Data:", orderData);

        // แปลงข้อมูลเป็น FormData และส่งไปยัง API
        const formData = transformObjectToFormData(orderData);

        console.log("FormData Entries:", Array.from(formData.entries()));

        const orderResponse = await api.pawn.updateInterest(
          selectedProduct?.id,
          formData
        );

        if (!orderResponse.isStatus) {
          console.error("Error creating order:", orderResponse);
          alert("Error creating order. Please try again.");
          return;
        }

        // สร้าง order สำเร็จ
        setOrder(orderResponse.data);
        setTimeout(() => {
          setLoading(false);
          setIsSuccess(true);
        }, 1000);
      } catch (error) {
        setLoading(false);
        console.error("Error submitting form:", error);
        alert("An error occurred. Please try again.");
      }
    },
  });

  const handlePrintPDF = async () => {
    if (order) {
      await api.pawn
        .getPrintPdfInterestOrder(order)
        .then((res) => {
          const url = window.URL.createObjectURL(
            new Blob([res.data], { type: "application/pdf" })
          );
          window.open(url, "_blank");
        })
        .catch((err) => {
          console.error("Error getting PDF:", err);
          alert("An error occurred. Please try again.");
        });
    }
  };

  const handleClose = () => {
    setFiles1([]); // Clear product images
    setFiles2([]); // Clear customer images
    formik.resetForm();
    setCurrentStep(1);
    setProductBoxes([{ id: 1, isExpanded: false }]);
    setNewIds([]);
    setLoading(false);
    setIsSuccess(false);
    setOrder(null);
    onClose();
    fetchProductData();
  };
  // console.log("display work", selectedProduct);

  // ฟังก์ชันลบรูป
  const handleImageDelete = (boxId, imageIndex) => {
    const currentImages = formik.values[`images_${boxId}`] || [];

    // Safeguard against undefined or null images array
    const updatedImages = currentImages.filter(
      (_, index) => index !== imageIndex
    );

    formik.setFieldValue(`images_${boxId}`, updatedImages);
  };

  // console.log("selectedProduct", selectedProduct);

  // ฟังก์ชันช่วยสำหรับแมปค่า
  const mapSelectedProductToField = (selectedProduct, fieldName) => {
    const mapping = {
      prefix: selectedProduct.prefix,
      fullName: selectedProduct.customer_name,
      idCardNumber: selectedProduct.idcard,
      phoneNumber: selectedProduct.phonenumber,
      address: selectedProduct.address,
      nationality: selectedProduct.nationality || "ไทย",
    };

    return mapping[fieldName];
  };

  // ค้นหาดัชนีของเดือนที่ยังไม่ได้ชำระตัวแรกเพื่อใช้เป็นตัวบอกว่าเดือนถัดไปไม่สามารถเลือกได้
  const firstUnpaidIndex = selectedProduct?.pawn_transactions.findIndex(
    (transaction) => transaction.payment_status === "ยังไม่ชำระ"
  );

  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [penalty, setPenalty] = useState(0);
  const [visibleTransactions, setVisibleTransactions] = useState([]);

  useEffect(() => {
    // Initialize visibleTransactions with the index of the first unpaid transaction
    if (selectedProduct?.pawn_transactions) {
      const firstUnpaidIndex = selectedProduct.pawn_transactions.findIndex(
        (transaction) => transaction.payment_status.trim() !== "ชำระเงินแล้ว"
      );
      if (firstUnpaidIndex !== -1) {
        setVisibleTransactions([firstUnpaidIndex]);
      }
    }
  }, [selectedProduct]);

  // ฟังก์ชันสำหรับจัดการการเลือก checkbox
  const handleCheckboxChange = (transaction, checked, index) => {
    console.log("Selected Transaction:", transaction);
    console.log("Checked:", checked, "Index:", index);

    if (checked) {
      // เพิ่ม transaction ที่เลือก
      setSelectedTransactions((prev) => {
        if (!prev.some((t) => t.id === transaction.id)) {
          return [...prev, transaction];
        }
        return prev;
      });

      // เพิ่ม index ถัดไป
      setVisibleTransactions((prev) => {
        const nextIndex = index + 1;
        return prev.includes(nextIndex) ? prev : [...prev, nextIndex];
      });
    } else {
      // ลบ transaction ที่ยกเลิกและรายการที่มี index มากกว่า
      setSelectedTransactions((prev) => {
        return prev.filter(
          (t) => selectedProduct.pawn_transactions.indexOf(t) < index
        );
      });

      // ลบ index ที่มากกว่า
      setVisibleTransactions((prev) =>
        prev.filter((visibleIndex) => visibleIndex <= index)
      );
    }
  };

  console.log("selectedTransactions", selectedTransactions);

  // คำนวณยอดรวม
  const checkedCount = selectedTransactions.filter((transaction) => {
    return (
      transaction.payment_status === "ชำระแล้ว" ||
      selectedTransactions.includes(transaction)
    );
  }).length;

  // คำนวณดอกเบี้ยโดยใช้จำนวน checkbox ที่ถูกเลือก
  let interestAmount = 0;
  selectedProduct?.order_pawns?.map((pawn) => {
    let sum = 0;
    sum = checkedCount * (pawn.interest_rate / 100) * pawn.pawn_price;
    interestAmount += sum;
  });

  // คำนวณ totalAmount โดยรวม interestAmount
  const totalAmount =
    // checkedCount +
    // Number(selectedProduct?.sum_product_total_price || 0) +
    Number(penalty) + interestAmount;

  useEffect(() => {
    formik.setFieldValue("total_interest", totalAmount);
  }, [totalAmount]);

  useEffect(() => {
    if (!open) {
      setSelectedTransactions([]);
      interestAmount = 0;
    }
  }, [open]);

  // ฟังก์ชันการแสดงฟิลด์ Checkbox
  const renderFieldsCheckbox = () => {
    return (
      <Box display="flex" flexDirection="column" gap={2}>
        {selectedProduct?.pawn_transactions.map((transaction, index) => {
          const isPaid = transaction.payment_status.trim() === "ชำระเงินแล้ว";
          const isVisible = isPaid || visibleTransactions.includes(index);

          console.log("isVisible", isVisible);
          console.log("isPaid", isPaid);
          console.log(
            "selectedTransactions",
            selectedTransactions.some((t) => t.id === transaction.id)
          );

          return (
            <Box
              key={transaction.id}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center">
                <Checkbox
                  checked={
                    isPaid ||
                    selectedTransactions.some((t) => t.id === transaction.id)
                  }
                  disabled={isPaid || !isVisible}
                  onChange={(e) =>
                    handleCheckboxChange(transaction, e.target.checked, index)
                  }
                />
                <Typography variant="body1" sx={{ marginRight: 2 }}>
                  เดือนที่ {transaction.month}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {transaction.payment_date
                    ? `วันที่ชำระ: ${transaction.payment_date}`
                    : "ยังไม่ชำระ"}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{
                    ml: 2,
                  }}
                >
                  สถานะ: {transaction.payment_status}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{
                    ml: 2,
                  }}
                >
                  ยอดชำระ:{" "}
                  {selectedProduct?.sum_product_total_price *
                    (interestRate / 100)}{" "}
                  บาท/เดือน
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    );
  };

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFields = (fields, selectedProduct) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>

            {field.type === "autocomplete" ? (
              <Autocomplete
                id={field.name}
                options={categoryOptions}
                getOptionLabel={(option) => option.label}
                value={formik.values.category_id}
                onChange={(event, newValue) => {
                  if (!field.disabled) {
                    formik.setFieldValue("category_id", newValue);
                  }
                }}
                disabled={field.disabled}
                fullWidth
                sx={{
                  flexGrow: 1,
                  ".MuiAutocomplete-inputRoot": {
                    height: "40px",
                    padding: "0px !important", // Ensure consistent padding
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name={field.name}
                    error={
                      formik.touched[field.name] &&
                      Boolean(formik.errors[field.name])
                    }
                    helperText={
                      formik.touched[field.name] && formik.errors[field.name]
                    }
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                )}
              />
            ) : (
              <TextField
                disabled={field.disabled}
                id={field.name}
                name={field.name}
                type={field.type}
                value={
                  selectedProduct
                    ? mapSelectedProductToField(selectedProduct, field.name)
                    : ""
                }
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched[field.name] &&
                  Boolean(formik.errors[field.name])
                }
                helperText={
                  formik.touched[field.name] && formik.errors[field.name]
                }
                fullWidth
                InputProps={{ sx: { height: "40px", padding: "0px" } }} // Ensure consistent height
              />
            )}
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  const showData = () => {
    return console.log("ก็เข้านะ");
  };

  const [expandedBoxes, setExpandedBoxes] = useState();

  // ฟังก์ชันการแสดงฟิลด์ของ Product
  const renderProductBoxes = () => {
    return selectedProduct?.order_pawns.map((box) => (
      <Box
        key={box.id}
        sx={{
          my: 2,
          border: "1px solid #ddd",
          p: 2,
          borderRadius: "12px",
          backgroundColor: "#ffffff",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center" // Add this to center items vertically
          onClick={() => toggleExpand(box.id)}
        >
          <Typography variant="subtitle1">{box.product_name}</Typography>
          <div>
            <IconButton
              disabled={productBoxes.length > 1 ? false : true}
              size="small"
              color="#ccc"
              onClick={(e) => {
                e.stopPropagation(); // Prevent toggleExpand from triggering on delete click
                handleDeleteBox(box.id); // Call the delete function
              }}
            >
              {/* <DeleteIcon /> */}
            </IconButton>
            <IconButton
              size="small"
              color="#ccc"
              onClick={() => handleExpandClick(box.id)}
              style={{
                transform: expandedRow === box.id ? "rotate(180deg)" : "none",
                transition: "transform 0.2s ease-in-out",
                marginLeft: "10px",
              }}
            >
              <ExpandMoreIcon />
            </IconButton>
          </div>
        </Box>
        <Collapse in={expandedBoxes === box.id}>
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Divider sx={{ borderColor: "#00BB9F", borderWidth: 1 }} />

            {/* Product Code Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>รหัสสินค้า {""}</Typography>
                    {/* <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                      <InfoIcon style={{ color: "#e5e5e5", marginRight: 10 }} />
                    </Tooltip> */}
                  </div>
                </Grid>

                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`product_code_${box.id}`} // ใช้ id เพื่อแยกชื่อ
                    value={formik.values[`product_code_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    error={
                      formik.touched[`product_code_${box.id}`] &&
                      Boolean(formik.errors[`product_code_${box.id}`])
                    }
                    helperText={
                      formik.touched[`product_code_${box.id}`] &&
                      formik.errors[`product_code_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Product Code2 Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>รหัส 2 {""}</Typography>
                    <Tooltip title="รหัสสินค้าภายในร้านที่สามารถกำหนดเองได้">
                      <InfoIcon style={{ color: "#e5e5e5", marginRight: 10 }} />
                    </Tooltip>
                  </div>
                </Grid>

                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`product_code_com_${box.id}`} // ใช้ id เพื่อแยกชื่อ
                    value={formik.values[`product_code_com_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    error={
                      formik.touched[`product_code_com_${box.id}`] &&
                      Boolean(formik.errors[`product_code_com_${box.id}`])
                    }
                    helperText={
                      formik.touched[`product_code_com_${box.id}`] &&
                      formik.errors[`product_code_com_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Name Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ชื่อสินค้า{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`product_name_${box.id}`}
                    value={formik.values[`product_name_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    error={
                      formik.touched[`product_name_${box.id}`] &&
                      Boolean(formik.errors[`product_name_${box.id}`])
                    }
                    helperText={
                      formik.touched[`product_name_${box.id}`] &&
                      formik.errors[`product_name_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Category Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    หมวดหมู่{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <Autocomplete
                    disabled
                    id={`category_id_${box.id}`}
                    options={categoryOptions}
                    getOptionLabel={(option) => option.label || ""} // ใช้ label เพื่อแสดงชื่อ category
                    value={
                      // ตรวจสอบว่าค่าที่ตั้งอยู่ใน formik.values มี id ตรงกับตัวเลือกใน categoryOptions หรือไม่
                      categoryOptions.find(
                        (option) =>
                          option.id ===
                          formik.values[`category_id_${box.id}`]?.id
                      ) || null // หากไม่พบ ให้ส่ง null ไป
                    }
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        `category_id_${box.id}`,
                        newValue?.id || "" // เก็บเฉพาะ id ใน Formik
                      );
                    }}
                    fullWidth
                    sx={{
                      ".MuiAutocomplete-inputRoot": {
                        height: "40px", // กำหนดความสูงให้เท่ากัน
                        padding: "0 8px", // เพิ่ม padding เล็กน้อย
                      },
                      ".MuiOutlinedInput-root": {
                        height: "40px", // กำหนดความสูงให้สม่ำเสมอใน wrapper
                      },
                      ".MuiAutocomplete-input": {
                        padding: "0px", // กำหนด padding ให้น้อยลง
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        {...params}
                        name={`category_id_${box.id}`} // ใช้ name ที่ถูกต้องในการตรวจสอบ validation
                        error={
                          formik.touched[`category_id_${box.id}`] &&
                          Boolean(formik.errors[`category_id_${box.id}`])
                        }
                        helperText={
                          formik.touched[`category_id_${box.id}`] &&
                          formik.errors[`category_id_${box.id}`]
                        }
                        fullWidth
                        InputProps={{
                          ...params.InputProps,
                          sx: { height: "40px", padding: "0px" }, // กำหนดความสูงให้สม่ำเสมอ
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Detail Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>รายละเอียด</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`detail_${box.id}`}
                    value={formik.values[`detail_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`detail_${box.id}`] &&
                      Boolean(formik.errors[`detail_${box.id}`])
                    }
                    helperText={
                      formik.touched[`detail_${box.id}`] &&
                      formik.errors[`detail_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Blemishes Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>ตำหนิ</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`blemishes_${box.id}`}
                    value={formik.values[`blemishes_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`blemishes_${box.id}`] &&
                      Boolean(formik.errors[`blemishes_${box.id}`])
                    }
                    helperText={
                      formik.touched[`blemishes_${box.id}`] &&
                      formik.errors[`blemishes_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Size Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>ขนาด</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`size_${box.id}`}
                    value={formik.values[`size_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`size_${box.id}`] &&
                      Boolean(formik.errors[`size_${box.id}`])
                    }
                    helperText={
                      formik.touched[`size_${box.id}`] &&
                      formik.errors[`size_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Total amount Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    จำนวน{" "}
                    {/* <span style={{ color: "red", marginLeft: "3px" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`total_amount_${box.id}`}
                    value={formik.values[`total_amount_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`total_amount_${box.id}`] &&
                      Boolean(formik.errors[`total_amount_${box.id}`])
                    }
                    helperText={
                      formik.touched[`total_amount_${box.id}`] &&
                      formik.errors[`total_amount_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Price Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ราคาทุน{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`price_${box.id}`}
                    value={formik.values[`price_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`price_${box.id}`] &&
                      Boolean(formik.errors[`price_${box.id}`])
                    }
                    helperText={
                      formik.touched[`price_${box.id}`] &&
                      formik.errors[`price_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Total Price Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>
                    ราคารวม{""}
                    {/* <span style={{ marginLeft: "4px", color: "red" }}>*</span> */}
                  </Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`total_price_${box.id}`}
                    value={formik.values[`total_price_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched[`total_price_${box.id}`] &&
                      Boolean(formik.errors[`total_price_${box.id}`])
                    }
                    helperText={
                      formik.touched[`total_price_${box.id}`] &&
                      formik.errors[`total_price_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Notes Row */}
            <Grid item xs={12}>
              <Grid container alignItems="center">
                <Grid item xs={2}>
                  <Typography>หมายเหตุ</Typography>
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    disabled
                    fullWidth
                    name={`notes_${box.id}`}
                    value={formik.values[`notes_${box.id}`] || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // <-- Add onBlur
                    error={
                      formik.touched[`notes_${box.id}`] &&
                      Boolean(formik.errors[`notes_${box.id}`])
                    }
                    helperText={
                      formik.touched[`notes_${box.id}`] &&
                      formik.errors[`notes_${box.id}`]
                    }
                    InputProps={{
                      sx: { height: "40px", padding: "0px" }, // Ensure consistent height
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Product Image Row */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 2 }}>
                รูปทรัพย์
              </Typography>
              <Grid item xs={12}>
                <div>
                  {Array.isArray(formik.values[`images_${box.id}`]) &&
                  formik.values[`images_${box.id}`].length > 0 ? (
                    <div>
                      {/* แสดงภาพ */}
                      {formik.values[`images_${box.id}`].map(
                        (imageUrl, index) => (
                          <img
                            key={index}
                            src={imageUrl}
                            alt={`Image ${index + 1} for Box ${box.id}`}
                            style={{
                              width: "150px",
                              height: "150px",
                              objectFit: "cover",
                              marginRight: "10px",
                            }}
                          />
                        )
                      )}
                    </div>
                  ) : (
                    <p>No images available for Box {box.id}</p>
                  )}
                </div>
              </Grid>

              {error1 && (
                <Typography variant="caption" color="error">
                  {error1}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Collapse>
      </Box>
    ));
  };

  // ฟังก์ชันการแสดงฟิลด์ Customer
  const renderFieldsCondition = (fields, selectedProduct) => {
    return fields.map((field, index) => (
      <React.Fragment key={index}>
        <Grid item xs={12} sm={12} sx={{ margin: 2 }}>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              sx={{ width: "200px", whiteSpace: "nowrap" }}
            >
              {field.label}
              {field.required && (
                <span style={{ marginLeft: "4px", color: "red" }}>*</span>
              )}
            </Typography>

            {field.type === "autocomplete" ? (
              <Autocomplete
                id={field.name}
                options={payment_channelOptions}
                getOptionLabel={(option) => option.label}
                value={formik.values.payment_channel}
                onChange={(event, newValue) => {
                  if (!field.disabled) {
                    formik.setFieldValue("payment_channel", newValue);
                  }
                }}
                disabled={field.disabled}
                fullWidth
                sx={{
                  ".MuiAutocomplete-inputRoot": {
                    height: "40px",
                    padding: "0px 0px 0px 7px !important",
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name={field.name}
                    error={
                      formik.touched[field.name] &&
                      Boolean(formik.errors[field.name])
                    }
                    helperText={
                      formik.touched[field.name] && formik.errors[field.name]
                    }
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      sx: { height: "40px" }, // Ensure consistent height
                    }}
                  />
                )}
              />
            ) : (
              <TextField
                disabled={field.disabled}
                id={field.name}
                name={field.name}
                type={field.type}
                value={formik.values[field.name]}
                onChange={formik.handleChange}
                {...getFieldProps(field.name)}
                error={
                  formik.touched[field.name] &&
                  Boolean(formik.errors[field.name])
                }
                helperText={
                  formik.touched[field.name] && formik.errors[field.name]
                }
                fullWidth
                InputProps={{
                  sx: { height: "40px", padding: "0px" }, // Ensure consistent height and padding
                  inputProps: {
                    style: {
                      "-moz-appearance": "textfield",
                      "-webkit-appearance": "none",
                      appearance: "none",
                    },
                    maxLength:
                      field.name === "idCardNumber"
                        ? 13
                        : field.name === "phoneNumber"
                        ? 10
                        : undefined,
                    inputMode: field.type === "text" ? "numeric" : undefined,
                    pattern: field.type === "text" ? "[0-9]*" : undefined,
                  },
                }}
              />
            )}
          </Box>
        </Grid>
      </React.Fragment>
    ));
  };

  // console.log("display formik.values", formik.values);
  //กรณีปิดหน้าต่าง Modal
  const handleCancel = () => {
    const formHasUnsavedChanges = Object.keys(touched).some(
      (field) => touched[field]
    );

    // console.log('formHasUnsavedChanges', formHasUnsavedChanges);
    // Prompt the user to confirm before closing if there are unsaved changes
    if (formHasUnsavedChanges) {
      Swal.fire({
        html: `
          <div style="display: flex; align-items: center; justify-content: space-between;">
            <!-- Left side icon/picture -->
            <div style="margin-right: 20px;">
              <img src="${SaveIcon}" alt="warning icon" width="300" height="300"/>
            </div>
      
            <!-- Right side text and buttons -->
            <div style="flex: 1;">
              <h2 style="font-size: 24px; color: #333;">ยืนยันการบันทึกหรือไม่</h2>
              <div id="custom-buttons" style="display: flex; justify-content: flex-end; margin-top: 20px;">
                <!-- React buttons will be injected here -->
              </div>
            </div>
          </div>
        `,
        showCancelButton: false, // Disable default buttons
        showConfirmButton: false, // Disable default buttons
        customClass: {
          container: "swal2-container-custom",
        },
        didOpen: () => {
          document.querySelector(".swal2-container-custom").style.zIndex = 1500;

          // Render your React button components after the Swal modal opens
          ReactDOM.render(
            <>
              <GradientButton
                onClick={() => {
                  // Handle cancel behavior
                  Swal.close(); // Close Swal
                }}
                style={{ width: "100%", marginBottom: "10px" }} // Make full width
              >
                ยกเลิก
              </GradientButton>
              <GradientButtonOutline
                onClick={() => {
                  // Close the current Swal first before showing the confirmation Swal
                  Swal.close();
                  formik.resetForm();
                  setFiles1([]); // Clear product images
                  setFiles2([]); // Clear customer images
                  setInitialProductUrls([]); // Clear initial product image URLs
                  // setInitialCustomerUrls([]);
                  setDeletedImageIds([]);
                  onClose();
                  setNewIds([]);
                }}
                style={{ width: "100%" }}
              >
                ตกลง
              </GradientButtonOutline>
            </>,
            document.getElementById("custom-buttons") // Inject React components into this div
          );
        },
      });
    } else {
      formik.resetForm();
      setFiles1([]); // Clear product images
      setFiles2([]); // Clear customer images
      setInitialProductUrls([]); // Clear initial product image URLs
      // setInitialCustomerUrls([]);
      setDeletedImageIds([]);
      onClose();
      setNewIds([]);
    }
  };

  // Function to handle button click
  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName); // Set the clicked button as active
  };

  const { errors, touched, getFieldProps, handleSubmit } = formik;

  // ใช้สำหรับการคิดค่าของ ราคา * จำนวน = จำนวนทั้งหมดแล้วนำไปเก็บไว้ใน Formik id นั้นๆ
  // useEffect(() => {
  //   productBoxes.forEach((box) => {
  //     const totalAmount = formik.values[`total_amount_${box.id}`];
  //     const price = formik.values[`price_${box.id}`];

  //     if (totalAmount && price) {
  //       const totalPrice = Number(totalAmount) * Number(price);
  //       formik.setFieldValue(`total_price_${box.id}`, totalPrice);
  //     }
  //   });
  // }, [formik.values, formik.setFieldValue, productBoxes]);

  // console.log("display formik naja", formik.values);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        //ป้องกันการกดเบื้องหลังแล้วหลุด
        if (reason !== "backdropClick") onClose();
      }}
      disableEscapeKeyDown
      fullWidth
      maxWidth="lg"
      sx={{
        borderRadius: "8px",
      }}
    >
      {currentStep === 1 ? (
        <>
          {/* หน้าที่ 1 : Form */}
          <DialogTitle style={{ backgroundColor: "#F1F2F7" }}>
            <Typography variant="h4">รายการต่อดอก</Typography>
          </DialogTitle>
          <DialogContent style={{ backgroundColor: "#F1F2F7" }}>
            <form onSubmit={formik.handleSubmit}>
              {/* Render the product boxes */}
              <Grid item xs={12} sx={{ mx: 2 }}>
                <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                  ข้อมูลลูกค้า
                </Typography>
                <Paper sx={{ p: 2, borderRadius: "12px" }}>
                  <Grid container>
                    <Grid item xs={7}>
                      {renderFields(customerFields, selectedProduct)}
                    </Grid>
                    <Grid item xs={5} sx={{ mt: 2 }}>
                      {selectedProduct ? (
                        <img
                          src={selectedProduct.customer_image}
                          alt="Preview"
                          style={{
                            width: "200px",
                            height: "200px",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        <Dropzone
                          files={files2}
                          setFiles={setFiles2}
                          setError={setError2}
                        />
                      )}
                      {error2 && (
                        <Typography variant="caption" color="error">
                          {error2}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Paper>

                <Grid items xs={12}>
                  {/* Render the product boxes */}
                  <Typography sx={{ mb: 2, mt: 3, ml: 2 }} variant="h5">
                    ข้อมูลสินค้า
                  </Typography>
                  {renderProductBoxes()}
                </Grid>

                <Typography sx={{ mb: 1, ml: 2 }} variant="h5">
                  ต่อดอก
                </Typography>
                <Paper sx={{ p: 2, borderRadius: "12px" }}>
                  <Grid container>
                    <Grid item xs={12}>
                      {renderFieldsCheckbox()}
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-end"
                        justifyContent={"flex-end"}
                        sx={{
                          width: "100%",
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={9}>
                            <Typography
                              variant="subtitle1"
                              sx={{ textAlign: "right" }}
                            >
                              อัตราดอกเบี้ยร้อยละ:
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              variant="subtitle1"
                              sx={{ textAlign: "right" }}
                            >
                              {interestRate}
                            </Typography>
                          </Grid>
                          <Grid item xs={1}>
                            <Typography variant="subtitle1">
                              ต่อเดือน
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={9}>
                            <Typography
                              variant="subtitle1"
                              sx={{ textAlign: "right" }}
                            >
                              ยอดดอกเบี้ยที่ต้องชำระทั้งหมด:
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              variant="subtitle1"
                              sx={{ textAlign: "right", color: "#00BB9F" }}
                            >
                              {totalAmount.toFixed(2)}
                            </Typography>
                          </Grid>
                          <Grid item xs={1}>
                            <Typography variant="subtitle1">บาท</Typography>
                          </Grid>
                        </Grid>
                      </Box>
                      {renderFieldsCondition(conditionPawn)}
                      {/* Product Slip Row */}
                      <Box sx={{ mx: 2 }}>
                        <Typography>
                          หลักฐานการชำระเงิน{""}
                          <span style={{ marginLeft: "4px", color: "red" }}>
                            *
                          </span>
                        </Typography>
                        <Dropzone
                          files={files1}
                          setFiles={setFiles1}
                          setError={setError1}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Paper>
                {/* <Paper sx={{ p: 2, borderRadius: "12px", mt: 2 }}>
                  <Grid container>
                    <Grid item xs={12}>
                      // <TableModal
                       // columns={columns}
                       // data={selectedProduct ? [selectedProduct] : []}
                      // />
                    </Grid>
                  </Grid>
                </Paper> */}
              </Grid>
            </form>
          </DialogContent>

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <Button
                  variant="outlined"
                  onClick={handleCancel}
                  sx={{
                    borderRadius: "12px", // Make the button circular
                    minWidth: "40px", // Adjust the width
                    minHeight: "40px", // Adjust the height
                    padding: 0, // Remove padding to center the icon better
                    borderColor: "#c4c4c4", // Light grey border
                    color: "#6c6c6c", // Light grey icon color
                    display: "flex", // Ensure flexbox is used
                    alignItems: "center", // Center vertically
                    justifyContent: "center", // Center horizontally
                    "&:hover": {
                      borderColor: "#a0a0a0", // Darker grey on hover
                    },
                  }}
                >
                  <ArrowBackIosIcon
                    fontSize="small"
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </Button>
                {/* <GradientButton
                  type="submit"
                  onClick={formik.handleSubmit}
                  style={{ marginRight: "20px" }}
                >
                  บันทึก
                </GradientButton> */}
                <GradientButtonOutline type="submit" onClick={handleNextStep}>
                  ดูตัวอย่าง
                </GradientButtonOutline>
              </Grid>
            </Grid>
          </DialogActions>
        </>
      ) : (
        <>
          {/* Step 2: Confirmation Page */}
          <DialogTitle>
            <Typography variant="h4">ตัวอย่างแบบฟอร์มรายการต่อดอก</Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              {/* Left Side: PDF Preview (Scrollable) */}
              <Grid
                item
                xs={8}
                style={{
                  backgroundColor: "#f0f0f0",
                  padding: "20px",
                  height: "650px",
                  overflowY: "scroll",
                  overflowX: "hidden",
                }}
              >
                <Form data={formik.values} />
              </Grid>

              {/* Right Side: The Form or other content */}
              <Grid
                item
                xs={4}
                display={"flex"}
                flexDirection={"column"}
                style={{ padding: "20px" }}
              >
                <GradientShadow
                  isActive={activeButton === "pawnContract"}
                  onClick={() => handleButtonClick("pawnContract")}
                  style={{ margin: "10px" }}
                >
                  ใบเสร็จรับเงิน
                </GradientShadow>

                {/* <GradientShadow
                  isActive={activeButton === "saleRenewal"}
                  onClick={() => handleButtonClick("saleRenewal")}
                  style={{ margin: "10px" }}
                >
                  ใบขายฝาก / ต่ออายุ
                </GradientShadow> */}
                {/* Content for the right side */}
              </Grid>
            </Grid>
          </DialogContent>

          {/* <Divider style={{ marginTop: "0", marginBottom: "16px", mx: 2 }} /> */}

          <DialogActions
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0 16px 16px 16px",
              // backgroundColor: "#F1F2F7",
            }}
          >
            {/* Dialog Actions */}
            <Grid container sx={{ mx: 3 }}>
              <Grid item xs={12}>
                <Divider
                  style={{
                    marginTop: "0",
                    marginBottom: "16px",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                container
                justifyContent="space-between" // Apply flex properties to align buttons
              >
                <GradientButtonOutline
                  // GradientButtonOutlineon
                  onClick={handleBackToStep1}
                >
                  ยกเลิก
                </GradientButtonOutline>
                <Grid>
                  {isSuccess ? (
                    <>
                      <GradientButtonOutline
                        sx={{
                          width: "120px",
                          marginRight: "20px",
                        }}
                        endIcon={
                          <CheckCircle
                            sx={{
                              width: "16px",
                              height: "16px",
                            }}
                          />
                        }
                        id="btn-success"
                        onClick={handleClose}
                      >
                        เสร็จสิ้น
                      </GradientButtonOutline>
                      <GradientButton
                        id="btn-print-pdf"
                        onClick={handlePrintPDF}
                        sx={{ width: "100px" }}
                      >
                        พิมพ์
                      </GradientButton>
                    </>
                  ) : (
                    <>
                      <GradientButton
                        type="submit"
                        onClick={formik.handleSubmit}
                        style={{ marginRight: "20px", width: "150px" }}
                        disabled={loading}
                        endIcon={
                          loading ? (
                            <CircularProgress
                              color="inherit"
                              size={15}
                              thickness={5}
                            />
                          ) : null
                        }
                      >
                        บันทึก
                      </GradientButton>
                      <Tooltip
                        title={
                          <Typography
                            sx={{
                              fontSize: "14px",
                            }}
                          >
                            กรุณากดบันทึกก่อนพิมพ์
                          </Typography>
                        }
                        arrow={true}
                        placement="top"
                        disableHoverListener={isSuccess} // ปิด tooltip ถ้า isSuccess = true
                        disableFocusListener={isSuccess}
                      >
                        <span>
                          <GradientButtonOutline
                            disabled={!isSuccess}
                            sx={{
                              width: "100px",
                              border: "1px solid #ccc",
                            }}
                          >
                            พิมพ์
                          </GradientButtonOutline>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
};

export default ModalInterest;
